/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateTableNumberBodyRequest } from '../../models/update-table-number-body-request';

export interface PatchByOrderidTablenumber$Params {
  OrderId: number;
  body?: UpdateTableNumberBodyRequest;
}

export function patchByOrderidTablenumber(
  http: HttpClient,
  rootUrl: string,
  params: PatchByOrderidTablenumber$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, patchByOrderidTablenumber.PATH, 'patch');
  if (params) {
    rb.path('OrderId', params.OrderId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    }),
  );
}

patchByOrderidTablenumber.PATH = '/Orders/{OrderId}/tableNumber';
